const VerticalLine = () => (
  <div className="border-r-1 border-l-1 border-coolGray-300 h-6 w-0 relative left-1/2 flex-none"></div>
)

export default VerticalLine
